import { useEffect } from 'react';
import { invitationsApi } from '../api/invitations.api';
import { formatOptionsForSelect } from '../../../services/helpers';
import { useRoles } from '../../roles/hooks/useRoles';
import { STATUS_INVITATIONS } from '../interfaces/users.interface';
import { useDataTable } from '../../../hooks/useDataTable';
export const useInvitations = () => {
  const table = useDataTable(invitationsApi);
  const { setDataFilters ,names:namesRoles} = table;
  useEffect(() => {
    setDataFilters([
      {
        filter: 'status',
        value_filter: '',
        data: STATUS_INVITATIONS,
        width: 'col-span-3 max-[768px]:col-span-12',
      },
       {
        filter: 'role',
        value_filter: '',
        data: formatOptionsForSelect(namesRoles, 'name', 'name', 'Elegir role'),
        width: 'col-span-3 max-[768px]:col-span-12',
      },
    ]);
  }, [namesRoles,]);

  return {
    ...table,
  };
};
